import { defineMessages } from '@jutro/locale';

export default defineMessages({
    VehiclesInvolved: {
        id: 'ml.claim.views.ml-claim-details-vehicles.Vehicles Involved',
        defaultMessage: 'Vehicles Involved'
    },
    YourVehicle: {
        id: 'ml.claim.views.ml-claim-details-vehicles.Your Vehicle',
        defaultMessage: 'Your Vehicle'
    },
    NamedNonOwner: {
        id: 'ml.claim.views.ml-claim-details-vehicles.Named Non-Owner',
        defaultMessage: 'Named Non-Owner'
    },
    vin: {
        id: 'ml.claim.views.ml-claim-details-vehicles.VIN',
        defaultMessage: 'VIN:'
    },
    OtherVehicle: {
        id: 'ml.claim.views.ml-claim-details-vehicles.Other Vehicle',
        defaultMessage: 'Other Vehicle'
    }
});
